<template>
  <div class="mainDraft">
    <adx-sidebar />
    <div class="mainDraft__main">
      <div class="mainDraft__main__header">
        <h1 class="medium-title">Draft</h1>
        <div class="mainDraft__main__header__menubar">
          <router-link class="subhead title" tag="li" :to="{name: 'digitalscreendraft'}">Digital Screen</router-link>
          <router-link class="subhead title" tag="li" :to="{name: 'busdraft'}">Bus Advertising</router-link>
        </div>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/SideBar/Desktop'

export default {
  name: 'adx-',
  components: {
    'adx-sidebar': Sidebar,
  },
  props: {

  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>